import { render } from "./ProductRecommendationSlider.vue?vue&type=template&id=6d85cf2f"
import script from "./ProductRecommendationSlider.vue?vue&type=script&lang=js"
export * from "./ProductRecommendationSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__